import { isDefined } from '@morpho-org/morpho-ts'
import { deleteCookie, getCookie, setCookie } from 'cookies-next'
import { type PropertyPath, set, unset } from 'lodash-es'

import {
  COOKIE_STORAGE_ROOT_KEY,
  safeValidateUserSettings,
  USER_SETTINGS_VERSION,
  type UserSettings
} from './types'

const baseUserSettings: UserSettings = {
  version: USER_SETTINGS_VERSION
}

const USER_SETTINGS_COOKIE_MAX_AGE = 60 * 60 * 24 * 365

const USER_SETTINGS_COOKIE_OPTIONS = {
  path: '/',
  maxAge: USER_SETTINGS_COOKIE_MAX_AGE,
  sameSite: 'lax' as const,
  secure: process.env.NODE_ENV === 'production'
}

const USER_SETTINGS_DELETE_COOKIE_OPTIONS = {
  path: '/'
}

export const getUserSettingsCookie = (): UserSettings | null => {
  const cookie = getCookie(COOKIE_STORAGE_ROOT_KEY)
  const userSettings = safeValidateUserSettings(cookie)

  if (isDefined(cookie) && !isDefined(userSettings)) {
    deleteCookie(COOKIE_STORAGE_ROOT_KEY, USER_SETTINGS_DELETE_COOKIE_OPTIONS)
  }

  return userSettings
}

export const setUserSettingsCookie = (pathPropertyPath: PropertyPath, value: unknown) => {
  const currCookie = getUserSettingsCookie() || baseUserSettings
  const newCookie = set(currCookie, pathPropertyPath, value)
  setCookie(COOKIE_STORAGE_ROOT_KEY, JSON.stringify(newCookie), USER_SETTINGS_COOKIE_OPTIONS)
}

/** @internal */
export const deleteUserSettingsCookie = (pathPropertyPath: PropertyPath) => {
  const currCookie = getUserSettingsCookie()
  if (!currCookie) return

  const newCookie = { ...currCookie }
  unset(newCookie, pathPropertyPath)
  setCookie(COOKIE_STORAGE_ROOT_KEY, JSON.stringify(newCookie), USER_SETTINGS_COOKIE_OPTIONS)
}
